module.exports = __webpack_public_path__ + "static/media/Yellow-Stairs_8.5dbc526c.png";